import ResponseForm from './ResponseForm';

export default ResponseForm;
